import React from 'react'
import './HeroImage.css'
import foto from '../assets/images/ana-barber-2025-long.png'

const HeroImage = () => {
  return (
    <div className="hero-container">
      <div className="hero-text">
        <h1>Ana Lourdes Barber Sahig Endocrinóloga de adultos</h1>
        <p>
          • Médico Cirujano de la Universidad de La Habana y Universidad de Chile
        </p>
        <p>• Especialista en Endocrinología y Diabetes. 
          </p>
          <p>
          • Diplomado en Endocrinología Ginecológica en la Pontificia Universidad Católica de Chile.
        </p>
          <p>• Miembro activo de la SOCHED (Sociedad Chilena de Endocrinología y Diabetes)</p>
        <br />

        {/* Botón con link externo */}
        <a
          href="http://agendamiento.softwaremedilink.com/agendas/online/c71a6edfe2b8fb65d605ebdefa75a0d5cc60bd4f"
          target="_blank"
          rel="noopener noreferrer"
          className="hero-button"
        >
          Reservar Cita
        </a>
      </div>

      <div className="hero-image">
        <img src={foto} alt="Dra. Ana Lourdes Barber Sahig" />
      </div>
    </div>
  )
}

export default HeroImage
